import React, { Component } from "react";
import { Select, Spin, message, Radio, Space, Checkbox } from "antd";
import Bridge from "../../../utils/Bridge";
import { logEvent } from "../../../utils/analytics";
import dayjs from "dayjs";
import moment from "moment";
import { speech_demographics_form_type } from "../../../utils/consts";

const { Option } = Select;

export default class LanguageAndEducationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      is_english_first_language:"",
      if_not_english_first_language:"",
      if_not_english_first_language_other:"",
      highest_education:"",
      doctor_education:[],
      other_education:"",

      email:"",
      neurostamp_id:"",
      modality_id:"",
      field_data:[],
      other_language_options:[],
      education_options:[],
    
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type='+speech_demographics_form_type.language_and_education;
    Bridge.demographics.speech
      .get(params)
      .then((response) => {
        if (response.status == "1") {
          this.setState({
            email:response.email,
            neurostamp_id:response.neurostamp_id,
            modality_id:response.modality_id,
            field_data: response.field_data.language_and_education,
          })
          let other_language_options=[]
          let education_options=[]
          for(let item of response.field_data.language_and_education){
            if(item.field=='LANGFRST'){
              other_language_options.push({
                value: item.values,
                label:item.description
              })
            }
            if(item.field=='DEMOG10'){
              education_options.push({
                value: item.values,
                label:item.description
              })
            }
          }
          let doctor_education=[]
          for(let item of response.data){
            if(item.field=='DEMOG8'){
              this.setState({
                is_english_first_language:item.value
              })
            }
            if(item.field=='DEMOG10'){
              this.setState({
                highest_education:item.value
              })
            }
            if(item.field=='LANGFRST'){
              this.setState({
                if_not_english_first_language:item.value
              })
            }
            if(item.field=='LANGOTH'){
              this.setState({
                if_not_english_first_language_other:item.value
              })
            }
            if(item.field=='EDUCMD'){
              doctor_education.push('. . . . . . . . . . MD')
            }
            if(item.field=='EDUCPD'){
              doctor_education.push('. . . . . . . . . . PhD')
            }
            if(item.field=='DEMOG9'){
              this.setState({
                other_education:item.value
              })
            }
          }
          this.setState({
            loading:false,
            doctor_education:doctor_education,
            other_language_options: other_language_options,
            education_options:education_options
          })
        }else{
          this.setState({loading:false})
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  validateName = (field, label) => {
    // Check if the input contains only alphabetic characters
    // if (!/^[A-Za-z]+$/.test(field)) {
    //   // message.warning(`${label} can only contain alphabetic characters.`);
    //   return `${label} can only contain alphabetic characters.`;
    // }
    // Check if the length of the input is within a specific range
    if (field.length <= 2 || field.length > 30) {
      // message.warning(`${label} must be between 2 and 30 characters long.`);
      return `${label} must be between 2 and 30 characters long.`;
    }
    return 1;
  };
  // step 1
  save_details = () => {
    if (!this.state.is_english_first_language) {
      message.warning("Please select value of 'Is English your first language?' field");
      return;
    }
    if(this.state.is_english_first_language=='2'){
      if (!this.state.if_not_english_first_language) {
        message.warning("Please select first other language");
        return;
      }
      if (this.state.if_not_english_first_language=="99") {
        if (!this.state.if_not_english_first_language_other) {
          message.warning("Please select other language");
          return;
        }
      }
    }
    if (!this.state.highest_education) {
      message.warning("Please select highest education");
      return;
    }
    
    let field_data=this.state.field_data
    const uniqueNames = [...new Map(field_data.map(item => [item.field, item])).values()];
    let questions=[]
    for(let item of uniqueNames){
      if(item.field=='DEMOG8'){
        let obj={
          value:this.state.is_english_first_language,
          view_name:item.view_name,
          form:"Language and Education",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='DEMOG10'){
        let obj={
          value:this.state.highest_education,
          view_name:item.view_name,
          form:"Language and Education",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='LANGFRST'){
        let obj={
          value:this.state.if_not_english_first_language,
          view_name:item.view_name,
          form:"Language and Education",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='LANGOTH'){
        let obj={
          value:this.state.if_not_english_first_language_other,
          view_name:item.view_name,
          form:"Language and Education",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='DEMOG9'){
        let obj={
          value:this.state.other_education,
          view_name:item.view_name,
          form:"Language and Education",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='EDUCMD'){
        let obj={
          value:this.state.doctor_education.includes('. . . . . . . . . . MD') ?1:0,
          view_name:item.view_name,
          form:"Language and Education",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='EDUCPD'){
        let obj={
          value:this.state.doctor_education.includes('. . . . . . . . . . PhD') ?1:0,
          view_name:item.view_name,
          form:"Language and Education",
          field: item.field
        }
        questions.push(obj)
      }
    }
    let params = {
      data: JSON.stringify(questions),
      step: speech_demographics_form_type.language_and_education,
      action_type: this.props.is_update == true ? "update" : "insert",
      email:this.state.email,
      neurostamp_id:this.state.neurostamp_id,
      modality_id:this.state.modality_id,
    };
    this.setState({ loading: true });
    Bridge.demographics.speech
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_submitted", { step: "language_education" });
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(5);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeHighestEducation = (event) => {
    this.setState({
      highest_education: event.target.value,
      education_other_specification: "",
      doctor_education: [],
      other_education:""
    });
  };
  onChangeDoctorEducation = (e) => {
    let value = e.target.value;
    let tempArr = this.state.doctor_education;
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({ doctor_education: newArray });
    } else {
      tempArr.push(value);
      this.setState({ doctor_education: tempArr });
    }
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">Language and Education</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
          <div className="form-group">
              <label className="input-heading">
                Is English your first language?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    is_english_first_language: e.target.value,
                    if_not_english_first_language: "",
                    if_not_english_first_language_other:""
                  })
                }
                value={this.state.is_english_first_language}
                direction="vertical"
              >
                <Space direction="vertical">
                  <Radio value={"1"}>Yes</Radio>
                  <Radio value={"2"}>No</Radio>
                </Space>
              </Radio.Group>
              <div className="row">
                {this.state.is_english_first_language == "2" && (
                  <div className="col-lg-6 mt-3">
                    <label className="input-heading">
                      If No, Please specify:{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <Select
                      onChange={(value) =>
                        this.setState({ 
                          if_not_english_first_language: value,
                          if_not_english_first_language_other:""
                         })
                      }
                      value={this.state.if_not_english_first_language}
                      style={{
                        width: "100%",
                        height: 55,
                        maxWidth: 500,
                      }}
                    >
                      <Option value="">Select Language:</Option>
                      {this.state.other_language_options.map((item,index)=>(
                        <Option value={item.value} key={index}>{item.label}</Option>
                      ))}
                    </Select>
                  </div>
                )}
                <div className="col-lg-6"></div>
                {this.state.if_not_english_first_language == "99" && (
                  <div className="col-lg-6">
                    <input
                      type="text"
                      name="if_not_english_first_language_other"
                      placeholder="Other Language"
                      value={this.state.if_not_english_first_language_other}
                      onChange={(e) => {
                        this.setState({
                          if_not_english_first_language_other: e.target.value,
                        });
                      }}
                      style={{
                        width: "100%",
                        height: 55,
                        maxWidth: 500,
                        marginTop: 20,
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="form-group">
              <label className="input-heading">
              What is your highest level of education{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={this.onChangeHighestEducation}
                value={this.state.highest_education}
                direction="vertical"
              >
                <Space direction="vertical">
                  {this.state.education_options.map((item,index)=>{
                    return (
                      <Radio value={item.value} key={index}>
                        {item.label}
                      </Radio>
                    )
                  })}
                </Space>
              </Radio.Group>
            </div>
            {this.state.highest_education == 8 && (
              <div>
                <li style={{listStyleType: "none"}} className="mb-2">
                  <Checkbox
                    style={{fontSize: 17}}
                    checked={
                      this.state.doctor_education.includes(". . . . . . . . . . MD")
                        ? true
                        : false
                    }
                    value={". . . . . . . . . . MD"}
                    onChange={this.onChangeDoctorEducation}
                  >
                    . . . . . . . . . . MD
                  </Checkbox>
                </li>
                <li style={{listStyleType: "none"}}>
                  <Checkbox
                    style={{fontSize: 17}}
                    checked={
                      this.state.doctor_education.includes(". . . . . . . . . . PhD")
                        ? true
                        : false
                    }
                    value={". . . . . . . . . . PhD"}
                    onChange={this.onChangeDoctorEducation}
                  >
                    . . . . . . . . . . PhD
                  </Checkbox>
                </li>
              </div>
            )}
            {this.state.highest_education == 99 && (
              <div className="form-group">
                <input
                  type="text"
                  name="other_education"
                  placeholder="Other Education"
                  value={this.state.other_education}
                  onChange={(e) => {
                    this.setState({
                      other_education: e.target.value,
                    });
                  }}
                  style={{
                    width: "100%",
                    height: 55,
                    maxWidth: 500,
                    marginTop: 20,
                  }}
                />
              </div>
            )}
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => { logEvent("demographics_previous", { step: "language_education" }); this.props.set_active_step(3); }}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
